import config from 'config';
import Organization from 'entities/organization/model';
import User from 'entities/user/model';
import Campaign from 'entities/campaign/model';
import Deed from 'entities/deed/model';

type EntityType = Organization | User | Campaign | Deed;

export const getAppDomain = (entities: Array<EntityType | undefined | null>): string => {
  const defaultAppDomain = config.clientUrl;

  let entityAppDomain = (
    entities.filter(Boolean).find((entity) => Boolean(entity.appVanityDomain)) || {}
  ).appVanityDomain;

  if (entityAppDomain) {
    entityAppDomain = `https://${entityAppDomain}`;
  }

  return entityAppDomain || defaultAppDomain;
};
